import KpiCard from './KpiCard';
import { useDashboardContext } from './Context';
import { useEffect, useRef, useState } from 'react';
import { DashboardService } from './service';
import moment from 'moment';
import { useAuthContext } from '../../contexts/AuthContext';
import { CircleCheck, DollarSign, Percent } from 'lucide-react';

const service = new DashboardService();

interface DashboardData {
    totalSales: number;
    completedAppointments: number;
    totalSalesLastMonth: number;
    completedAppointmentsLastMonth: number;
    totalCommission: number;
}

export const DashboardHeader = () => {
    const { user } = useAuthContext();

    const [loading, setLoading] = useState(false);
    const { selectedDate, atendenteId } = useDashboardContext();
    const competence = moment(selectedDate).format('YYYY-MM');
    const previousCompetenceRef = useRef(competence);

    const [data, setData] = useState<DashboardData>({
        totalSales: 0,
        completedAppointments: 0,
        totalSalesLastMonth: 0,
        completedAppointmentsLastMonth: 0,
        totalCommission: 0,
    });

    useEffect(() => {
        const fetchData = async (currentCompetence: string) => {
            if (!loading) {
                try {
                    setLoading(true);
                    const response = await service.getInfoHeader(currentCompetence, atendenteId);
                    setData(response.data);
                } catch (e) {
                    console.error('Erro ao carregar os dados do dashboard:', e);
                } finally {
                    setTimeout(function () {
                        setLoading(false);

                        if (previousCompetenceRef.current !== currentCompetence) {
                            fetchData(previousCompetenceRef.current);
                        }
                    }, 300);
                }
            }
        };

        previousCompetenceRef.current = competence;
        fetchData(competence);
    }, [competence, atendenteId]);

    const currency = (value: number) => value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    return (
        <div className={`sf-dashboard-summary-grid ${loading ? 'opacity-50' : ''}`} aria-busy={loading}>
            <KpiCard title="Concluídos no mês" value={data.completedAppointments}
                subtitle={`${data.completedAppointmentsLastMonth} no mês anterior`} icon={CircleCheck} />
            {(user?.root || user?.admin) && (
                <KpiCard title="Faturamento no mês" value={currency(data.totalSales)}
                    subtitle={`${currency(data.totalSalesLastMonth)} no mês anterior`} icon={DollarSign} />
            )}
            <KpiCard title="Comissão no mês" value={currency(data.totalCommission)} icon={Percent} />
        </div>
    );
};
